import { render, staticRenderFns } from "./neocat.vue?vue&type=template&id=132adeb5&scoped=true"
import script from "./neocat.vue?vue&type=script&lang=js"
export * from "./neocat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132adeb5",
  null
  
)

export default component.exports